import { lazy } from "react";

const MedicalRecord = lazy(() => import("../components/medicalRecordComponent"));
const MedicalRecordReport = lazy(() => import("../components/medicalRecordReportComponent"));
const MedicalRecordDetailReport = lazy(() => import("../components/medicalRecordDetailReportComponent"));

export const MedicalRecordRoute = [
  {
    path: "medical-record",
    component: MedicalRecord,
  },
  {
    path: "medical-record/report",
    component: MedicalRecordReport,
  },
  {
    path: "medical-record/report/:id",
    component: MedicalRecordDetailReport,
  },
];
